import type { WavespeedModelConfig } from '../types';
import { clampTo } from '../../tools';

export const klingConfigs: Record<string, WavespeedModelConfig> = {
    'kwaivgi/kling-image-o3/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/kwaivgi/kling-image-o3/text-to-image
        apiPath: '/kwaivgi/kling-image-o3/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, image_resolution, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                resolution: clampTo(image_resolution?.toLowerCase() || '1k', ['1k', '2k', '4k'] as const, '1k'),
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'png',
                    ['png', 'jpeg', 'webp'] as const,
                    'png',
                ),
                shot_type: clampTo(
                    providerOptions?.shot_type || 'intelligent',
                    ['customize', 'intelligent'] as const,
                    'intelligent',
                ),
                // system
                num_images: 1,
            };
        },
    },
    'kwaivgi/kling-image-o3/edit': {
        // https://wavespeed.ai/zh-CN/models/kwaivgi/kling-image-o3/edit
        apiPath: '/kwaivgi/kling-image-o3/edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: aspectRatio === 'match' ? 'auto' : clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                resolution: clampTo(image_resolution?.toLowerCase() || '1k', ['1k', '2k', '4k'] as const, '1k'),
                // 图片 URL
                images: image_urls.slice(0, 10),
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'png',
                    ['png', 'jpeg', 'webp'] as const,
                    'png',
                ),
                shot_type: clampTo(
                    providerOptions?.shot_type || 'intelligent',
                    ['customize', 'intelligent'] as const,
                    'intelligent',
                ),
                // system
                num_images: 1,
            };
        },
    },
    'kwaivgi/kling-image-v3/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/kwaivgi/kling-image-v3/text-to-image
        apiPath: '/kwaivgi/kling-image-v3/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, image_resolution, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                resolution: clampTo(image_resolution?.toLowerCase() || '1k', ['1k', '2k'] as const, '1k'),
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'png',
                    ['png', 'jpeg', 'webp'] as const,
                    'png',
                ),
                shot_type: clampTo(
                    providerOptions?.shot_type || 'intelligent',
                    ['customize', 'intelligent'] as const,
                    'intelligent',
                ),
                // system
                num_images: 1,
            };
        },
    },
    'kwaivgi/kling-image-v3/edit': {
        // https://wavespeed.ai/zh-CN/models/kwaivgi/kling-image-v3/edit
        apiPath: '/kwaivgi/kling-image-v3/edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: aspectRatio === 'match' ? 'auto' : clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                resolution: clampTo(image_resolution?.toLowerCase() || '1k', ['1k', '2k'] as const, '1k'),
                // 图片 URL
                images: image_urls.slice(0, 10),
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'png',
                    ['png', 'jpeg', 'webp'] as const,
                    'png',
                ),
                shot_type: clampTo(
                    providerOptions?.shot_type || 'intelligent',
                    ['customize', 'intelligent'] as const,
                    'intelligent',
                ),
                // system
                num_images: 1,
            };
        },
    },
};